import { citylineFactory  } from "../../../FleetTracker/Infrastructure/Cityline";
import EventTarget from "@ungap/event-target";

interface EventMap {
    "source-updated": VehicleLocation;
}

export class LocationStore {
    private static _instance = new LocationStore();
    private _initializer: Promise<void>;
    private _eventTarget = new EventTarget();
    public static get instance() { return LocationStore._instance }
    private _vehicles: { [key: string]: VehicleLocation } = {};
    private constructor() { }

    private citylineEventHandler = (event: CustomEvent<VehicleLocation[]>) => {
        for (const location of event.detail) {
            this._vehicles[location.deviceId] = location;
            this.emit("source-updated", location);
        }
    }

    public getLocation(deviceId: string) { return this._vehicles[deviceId]; }

    addEventListener<K extends Extract<keyof EventMap, string>>(type: K, listener: (this: EventSource, ev: CustomEvent<EventMap[K]>) => any, options?: boolean | AddEventListenerOptions) {
        return this._eventTarget.addEventListener(type, listener, options);
    }

    removeEventListener<K extends Extract<keyof EventMap, string>>(type: K, listener: (this: EventSource, ev: CustomEvent<EventMap[K]>) => any, options?: boolean | AddEventListenerOptions) {
        return this._eventTarget.removeEventListener(type, listener, options);
    }

    private emit<K extends Extract<keyof EventMap, string>, T extends EventMap>(type: K, value: T[K]) {
        return this._eventTarget.dispatchEvent(new CustomEvent(type, { detail: value }));
    }

    public async start() {
        var client = citylineFactory.client;
        client.start();

        const initial = await citylineFactory.client.getFrame<VehicleLocation[]>("location");

        for (const location of initial) {
            this._vehicles[location.deviceId] = location;
            this.emit("source-updated", location);
        }

        citylineFactory.client.addEventListener("location", this.citylineEventHandler);
    }

    public static routeToColor = (route: string) => {
        switch (route.toLowerCase()) {
            case "tour a": return "#0000ff";
            case "tour b": return "#ff0000";
            case "tour c": return "#ff00ff";
            case "tour d": return "#339900";
            case "tour e": return "#006666";
            case "tour f": return "#999900";
            case "tour g": return "#817";
            case "tour h": return "#a35";
            case "tour i": return "#c66";
            case "tour j": return "#e94";
            case "tour k": return "#ed0";
            case "tour l": return "#9d5";
            case "tour m": return "#4d8";
            case "tour n": return "#2cb";
            case "tour o": return "#000";
            case "tour p": return "#09c";
            case "tour q": return "#36b";
            case "tour r": return "#639";
            case "tour s": return "#817";
            case "tour t": return "#a35";
            case "tour u": return "#c66";
            case "tour v": return "#e94";
            case "tour w": return "#ed0";
            case "tour x": return "#9d5";
            case "tour y": return "#4d8";
            case "tour z": return "#2cb";

            default:
                console.log("unknown route", route);
        }
    }
}

export interface VehicleLocation {
    deviceId: string;
    name: string;
    initials: string;
    phoneNumber: string;
    latitude: number;
    longitude: number;
    created: string;
}